<!-- Profile page for private users -->
@if (authService.isPrivateCustomer) {
    <app-private-profile [isInToolbar]="isInToolbar"></app-private-profile>
}

<!-- Profile page for business users -->
@if (!authService.isPrivateCustomer) {
    <app-business-profile [isInToolbar]="isInToolbar"></app-business-profile>
}
